// extracted by mini-css-extract-plugin
export const arrow = "Paginator__arrow__+KJw7";
export const arrowCellSize = "var(--paginator-size)";
export const arrowInner = "Paginator__arrowInner__Deamv";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const cell = "Paginator__cell__zHvgs";
export const current = "Paginator__current__d2tEd";
export const disabled = "Paginator__disabled__vbO1a";
export const ellipsis = "Paginator__ellipsis__Dq37C";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const page = "Paginator__page__BdLrk";
export const pageCellSize = "var(--paginator-cell-size)";
export const pages = "Paginator__pages__sUFhc";
export const paginator = "Paginator__paginator__XilK2";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const stretching = "Paginator__stretching__gMXD8";
export const textCenter = "Paginator__textCenter__Y3u3V";